import React from 'react';

interface FooterLogoProps {
  imageUrl: string;
  imageAlt: string;
}

const FooterLogo = ({ imageUrl, imageAlt }: FooterLogoProps) => {
  return (
    <img className="h-8 w-auto" src={imageUrl} alt={imageAlt} loading="lazy" />
  );
};

interface PaymentsLogosProps {
  items: FooterIconItem[];
}

const PaymentsLogos = ({ items }: PaymentsLogosProps) => {
  const logos = items.map((item) => {
    return (
      <img
        className="justify-center p-2"
        key={item.imageUrl}
        src={item.imageUrl}
        alt={item.imageAlt}
        loading="lazy"
      />
    );
  });

  return (
    <div className="flex py-4 justify-center items-center flex-wrap max-w-[220px] md:max-w-none">
      {logos}
    </div>
  );
};

export const Payments = ({
  imageUrl,
  imageAlt,
  items,
}: FooterPaymentAndDelivery) => {
  return (
    <div className="bg-gray-900 text-white">
      <div className="container flex flex-wrap m-auto justify-center flex-col items-center pt-7 lg:justify-between lg:flex-row lg:pt-0">
        <FooterLogo imageUrl={imageUrl} imageAlt={imageAlt} />
        <PaymentsLogos items={items} />
      </div>
    </div>
  );
};
